// TODO: 測試用資料，記得刪
export const PROGRAM_NAME_OPTIONS = [
  {
    label: '創意芳香手工皂',
    value: '創意芳香手工皂',
  },
  {
    label: '手作天然保養品',
    value: '手作天然保養品',
  },
  {
    label: '花藝設計與應用',
    value: '花藝設計與應用',
  },
  {
    label: '烘焙美食製作',
    value: '烘焙美食製作',
  },
  {
    label: '手工編織藝術',
    value: '手工編織藝術',
  },
  {
    label: '陶藝創作工坊陶藝創作工坊陶藝創作工坊陶藝創作工坊',
    value: '陶藝創作工坊',
  },
];
